__turbopack_context__.v({
  "MapArea": "_9nCmQW_MapArea",
  "skeleton-loading": "_9nCmQW_skeleton-loading",
});
